import React, { useState, useEffect, useRef, useCallback } from "react";
import "./EnrollWorkshop.css";

const API_URL = process.env.REACT_APP_API_URL;

function EnrollWorkshop() {
    const [filter, setFilter] = useState("upcoming");
    const [workshops, setWorkshops] = useState([]);
    const [loading, setLoading] = useState(true);
    const listRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleTabClick = (tab) => {
        setFilter(tab);
    };

    const fetchWorkshops = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${API_URL}/api/workshops/${filter}`
            );
            const data = await response.json();
            setWorkshops(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error fetching workshops:", error);
            setWorkshops([]);
        } finally {
            setLoading(false);
        }
    }, [filter]);

    useEffect(() => {
        fetchWorkshops();
    }, [fetchWorkshops]);
    const renderWorkshops = () => {
        if (loading) {
            return <p>Loading workshops...</p>;
        }

        if (workshops.length === 0) {
            return <p>No workshops found.</p>;
        }

        return (
            <>
                <div
                    className={`workshop-list ${
                        workshops.length === 1 ? "single" : ""
                    }`}
                    ref={listRef}
                >
                    {workshops.map((workshop, index) => (
                        <div
                            className="workshop-card"
                            key={index}
                            data-index={index}
                        >
                            <img src={require(`../images/${workshop.image}`)} alt={`${workshop.image} Dish`} />
                            <div className="workshop-info">
                                {/* Date/time on top */}
                                <p className="time-location">
                                    {workshop.date} • {workshop.time}
                                </p>

                                {/* Title + button side by side */}
                                <div className="title-row">
                                    <h3 className="workshop-title">
                                        {workshop.name}
                                    </h3>
                                    {workshop.isFull ? (
                                        <button className="signup-btn full">
                                            FULL
                                        </button>
                                    ) : filter === "past" ? (
                                        <button
                                            className="signup-btn past"
                                            disabled
                                        >
                                            SIGN UP
                                        </button>
                                    ) : (
                                        <a
                                            className="signup-btn"
                                            href={workshop.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            SIGN UP
                                        </a>
                                    )}
                                </div>

                                {/* Description / link */}
                                <a
                                    href={workshop.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Read more about this dish →
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pager dots for mobile horizontal scrolling */}
                {workshops.length > 1 && (
                    <div
                        className="pager-dots"
                        aria-hidden={workshops.length <= 1}
                    >
                        {workshops.map((_, idx) => (
                            <button
                                key={idx}
                                className={`pager-dot ${
                                    idx === activeIndex ? "active" : ""
                                }`}
                                onClick={() => {
                                    // Scroll the selected card into view
                                    const list = listRef.current;
                                    if (list && list.children[idx]) {
                                        list.children[idx].scrollIntoView({
                                            behavior: "smooth",
                                            inline: "center",
                                            block: "nearest",
                                        });
                                    }
                                }}
                                aria-label={`Go to workshop ${idx + 1}`}
                            />
                        ))}
                    </div>
                )}
            </>
        );
    };

    // Observe which card is in view (used for pager dot highlighting)
    useEffect(() => {
        const list = listRef.current;
        if (!list) return;

        const options = {
            root: list,
            rootMargin: "0px",
            threshold: 0.6,
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const idx = parseInt(entry.target.dataset.index, 10);
                    if (!Number.isNaN(idx)) setActiveIndex(idx);
                }
            });
        }, options);

        const children = Array.from(list.children || []);
        children.forEach((child) => observer.observe(child));

        return () => observer.disconnect();
    }, [workshops]);

    return (
        <section className="enroll-container">
            <div className="enroll-content">
                <h2>Enroll in a Workshop</h2>
                <p className="intro">
                    Cooking and celebrating knowledge with loved ones while
                    preparing delicious meals to share is the focal point of our
                    program. Enroll in one of our 100%{" "}
                    <span className="free-highlight">FREE</span> cooking
                    workshops today!
                </p>

                <div className="tabs">
                    <button
                        className={`tab ${
                            filter === "upcoming" ? "active" : ""
                        }`}
                        onClick={() => handleTabClick("upcoming")}
                    >
                        UPCOMING WORKSHOPS
                    </button>
                    <button
                        className={`tab ${filter === "past" ? "active" : ""}`}
                        onClick={() => handleTabClick("past")}
                    >
                        PAST WORKSHOPS
                    </button>
                </div>

                {/* <p className="monthly-theme">
                    This month, we are traveling to{" "}
                    <span className="highlight">
                        {filter === "upcoming" ? "Southeast Asia" : "Europe"}
                    </span>
                </p> */}

                <div className="scroll-container">
                    {renderWorkshops()}
                    <div className="fade-bottom" />
                </div>

                <p className="stay-tuned">Stay tuned for more next month :)</p>
            </div>
        </section>
    );
}

export default EnrollWorkshop;
